import src from "IMAGE";
export default { src, width: 56, height: 56, blurWidth: 8, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAMklEQVR42q2OMQ4AMAgCKaT//3LLYOKkDt4EJASACZIuSYW3doYcnE9461xYoJ1oT1Y8SzAAkRYZ+h0AAAAASUVORK5CYII="};
